import { useCallback } from 'react';
import { getCodeManagement } from '../../services/CodeMgt';
export const getDescriptionFromSessionStorage = (storageKey, value) => {
    const storedData = sessionStorage.getItem(storageKey);
    if (storedData) {
        const parsedData = JSON.parse(storedData);
        const match = parsedData.find((item) => item.value === value);
        return match ? match.description : '';
    }
    return '';
};
export const getListFromSessionStorage = (storageKey) => {
    const storedData = sessionStorage.getItem(storageKey);
    if (storedData) {
        const parsedData = JSON.parse(storedData);
        return parsedData;
    }
    return '';
};
const requiredKeys = [
    'primary-ssic-codes',
    'issuance-agency',
    'entity-status',
    'entity-type-display',
    'uen-status',
    'uen-entity-status',
    'issuance-agency-url',
    'suffix',
];
const useSessionData = () => {
    const fetchSessionData = useCallback(async () => {
        const isDataInSession = requiredKeys.every((key) => sessionStorage.getItem(key) !== null);
        if (isDataInSession) {
            return;
        }
        try {
            const res = await getCodeManagement();
            if (res.status === 'SUCCESS' && res.result) {
                res.result.forEach((item) => {
                    sessionStorage.setItem(item.codeTable, JSON.stringify(item.codeList));
                });
            }
        }
        catch (error) {
            console.error(error);
        }
    }, []);
    return fetchSessionData;
};
export default useSessionData;
